import EContracts from './e-contracts-container';

export default EContracts;